module.exports = __webpack_public_path__ + "img/economia.73f70dcd.jpg";